import * as yup from "yup";

export const initialState = {
    subject : "",
    requestType : "",
    category : "",
    subCategory : "",
    severity : "",
    hostName : "",
    // watchersEmail : "",
    description : "",
}

export const schema = yup.object().shape({
    subject: yup.string().required("Please enter the subject for ticket").matches(/^[a-zA-Z0-9]+[a-zA-Z0-9\.\,\_\ \:\;\"\/\-]*$/, "Should start with character only and special characters are not allowed").min(3, "Subject minimum length is 3 and maximum length is 50").max(50, "Subject minimum length is 3 and maximum length is 50"),
    requestType: yup.string().required("Please select a request type"),
    category: yup.string().required("Please select a category"),
    subCategory: yup.string().required("Please select a sub-category"),
    severity: yup.string().required("Please select a severity level"),
    hostName: yup.string().required("Please enter your notebook name").matches(/^[a-zA-Z0-9]+[a-zA-Z0-9\.\,\_\ \:\;\"\/\-]*$/, "Should start with character only and special characters are not allowed"),
    // watchersEmail: yup.array().max(5, "Maximum 5 member can be added as watcher"),
    // description: yup.string().required("Please enter the description about ticket").matches(/^[a-zA-Z0-9]+[a-zA-Z0-9\.\,\_\ \:\;\"\/\?\'\-]*$/, "Should start with character only and special characters are not allowed").min(3, "Description minimum length is 3 and maximum length is 1000").max(1000, "Description minimum length is 3 and maximum length is 1000"),
    description: yup.string().required("Please enter the description about ticket").matches(/^[a-zA-Z][a-zA-Z0-9_ ><?@+'`~^%&\*\[\]\{\}.!#|\\\"$';,:;=/\(\),\-\w\s+]*$/, "Should start with character only").min(3, "Description minimum length is 3 and maximum length is 1000").max(1000, "Description minimum length is 3 and maximum length is 1000"),

  });
  